import * as tslib_1 from "tslib";
import { OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { startOfDay, isSameDay, isSameMonth } from 'date-fns';
import { CalendarEvent, CalendarEventAction, CalendarEventTimesChangedEvent, CalendarMonthViewDay } from 'angular-calendar';
import { EmployeeCalendarEventModel } from './event.model';
import * as _moment from 'moment';
import { default as _rollupMoment } from 'moment';
import { takeUntil } from 'rxjs/operators';
var moment = _rollupMoment || _moment;
var EmployeeCalendarComponent = /** @class */ (function () {
    function EmployeeCalendarComponent(_matDialog, _calendarService, _companyService, _translationLoader, _translateService, dateAdapter) {
        this._matDialog = _matDialog;
        this._calendarService = _calendarService;
        this._companyService = _companyService;
        this._translationLoader = _translationLoader;
        this._translateService = _translateService;
        this.dateAdapter = dateAdapter;
        this.refresh = new Subject();
        this.addEventDisabled = false;
        this.locale = 'en';
        this.lang = localStorage.getItem('lang') || 'sr';
        this.categories = [6, 14, 15, 16, 17, 18];
        this.eventTypes = {};
        // Set the defaults
        this._unsubscribeAll = new Subject();
        this.view = 'month';
        this.viewDate = new Date();
        this.activeDayIsOpen = true;
        this.selectedDay = { date: startOfDay(new Date()) };
        this.company = this._companyService.activeCompany;
        this.actions = [
        // {
        //     label: '<i class="material-icons s-16">edit</i>',
        //     onClick: ({ event }: { event: CalendarEvent }): void => {
        //         this.editEvent('edit', event);
        //     }
        // },
        // {
        //     label: '<i class="material-icons s-16">delete</i>',
        //     onClick: ({ event }: { event: CalendarEvent }): void => {
        //         this.deleteEvent(event);
        //     }
        // }
        ];
        /**
         * Get events from service/server
         */
        // this.setEvents(null);
    }
    EmployeeCalendarComponent.prototype.getEventColor = function (type) {
        var colors = [{
                type: '',
                primary: '#666666',
                secondary: '#666666'
            }, {
                type: 'appointment',
                primary: '#F44336',
                secondary: '#FFCDD2'
            }, {
                type: 'declared job',
                primary: '#FF9800',
                secondary: '#D1E8FF'
            }, {
                type: 'bonus',
                primary: '#1E90FF',
                secondary: '#D1E8FF'
            }, {
                type: 'sick leave',
                primary: '#673AB7',
                secondary: '#D1C4E9'
            }, {
                type: 'day off',
                primary: '#673AB7',
                secondary: '#D1C4E9'
            }, {
                type: 'annual leave',
                primary: '#673AB7',
                secondary: '#D1C4E9'
            }, {
                type: 'Work_Schedule',
                primary: '#673AB7',
                secondary: '#D1C4E9'
            }];
        var retVal = colors[0];
        colors.forEach(function (item) {
            if (item.type === type) {
                retVal = item;
            }
        });
        return retVal;
    };
    EmployeeCalendarComponent.prototype.getCompanyEvents = function (date) {
        this._calendarService.getNonWorkingDays(date, this.company.id);
    };
    EmployeeCalendarComponent.prototype.getTeamEvents = function (date) {
        this._calendarService.getTeamWorkSchedule(date, this.company.id);
    };
    EmployeeCalendarComponent.prototype.checkNonWorkingEvent = function (events) {
        var retVal = false;
        events.forEach(function (event) {
            if (event.type === 'Non-Working_Day') {
                retVal = true;
            }
        });
        return retVal;
    };
    EmployeeCalendarComponent.prototype.getTranslations = function () {
        var _this = this;
        console.log('getTranslations');
        this._translationLoader.getLastLang()
            .then(function (response) {
            _this.lang = response['code'];
            _this._translationLoader.getMultipleTranslationCategories(_this.lang, _this.categories);
            _this.dateAdapter.setLocale(_this.lang);
            // set calendar locale
            if (_this.lang === 'sr') {
                _this.locale = 'sr-Latn';
            }
            else if (_this.lang === 'ua') {
                _this.locale = 'ru-UA';
            }
            else {
                _this.locale = _this.lang;
            }
        })
            .catch(function (err) { return Promise.reject(err); })
            .then(function () {
        }, function (err) {
        });
    };
    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------
    /**
     * On init
     */
    EmployeeCalendarComponent.prototype.ngOnInit = function () {
        var _this = this;
        var d = moment().format('YYYY-MM');
        this._calendarService.onMonthlyEventsUpdated
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(function (events) {
            _this.setEvents(events);
        });
        this._calendarService.onNonWorkinEventsUpdated
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(function (events) {
            _this.setNonWorkingDays(events);
        });
        this._calendarService.onTeamEventsUpdated
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(function (events) {
            _this.setTeamEventDays(events);
        });
        this._companyService.onCompanyChanged
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(function (response) {
            if (_this.company.id !== _this._companyService.activeCompany.id ? _this._companyService.activeCompany.id : response.id) {
                _this.company = _this._companyService.activeCompany;
                _this._calendarService.companyId = _this.company.id;
                _this._calendarService.getMonthlyEvents();
            }
        });
        // this._calendarService.getMonthlyEvents(d)
        // .then(response => {
        //     console.log(response);
        // });
        this._translationLoader.onLangChanged
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(function (value) {
            _this.getTranslations();
        });
        this.getTranslations();
    };
    EmployeeCalendarComponent.prototype.ngOnDestroy = function () {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    };
    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------
    /**
     * Set events
     */
    EmployeeCalendarComponent.prototype.setEvents = function (events) {
        var _this = this;
        this.eventsMonthly = events.data.map(function (item) {
            // item.actions = this.actions;
            var c = _this.getEventColor(item.type);
            return new EmployeeCalendarEventModel({
                actions: _this.actions,
                id: item.id,
                start: item.start_datetime,
                end: item.end_datetime,
                title: _this._translateService.instant(item.title),
                color: {
                    primary: c.primary,
                    secondary: c.secondary
                },
                isRecurring: item.is_recurring,
                type: item.type,
                frequenceTypeOfRecurring: item.frequence_type_of_recurring,
                endOfRecurring: item.end_of_recurring,
                meta: {
                    location: '',
                    notes: item.type
                }
            });
        });
        this.getCompanyEvents(this._calendarService.calendarLastDate);
    };
    EmployeeCalendarComponent.prototype.setNonWorkingDays = function (events) {
        var _this = this;
        this.addEventDisabled = false;
        this.eventsCompany = tslib_1.__spread(this.eventsMonthly, events.data.map(function (item) {
            var actual = moment(_this.viewDate).format('YYYY-MM-DD');
            var start = moment(item.start_datetime).format('YYYY-MM-DD');
            var end = moment(item.end_datetime).format('YYYY-MM-DD');
            var check = moment(actual).isBetween(start, end) || actual === start;
            if (!_this.addEventDisabled && check) {
                _this.addEventDisabled = true;
            }
            var c = _this.getEventColor(item.type);
            return new EmployeeCalendarEventModel({
                actions: [],
                id: item.id,
                start: item.start_datetime,
                end: item.end_datetime,
                title: _this._translateService.instant(item.title),
                color: {
                    primary: c.primary,
                    secondary: c.secondary
                },
                isRecurring: item.is_recurring,
                type: item.type,
                frequenceTypeOfRecurring: item.frequence_type_of_recurring,
                endOfRecurring: item.end_of_recurring,
                meta: {
                    location: '',
                    notes: item.type
                }
            });
        }));
        this.getTeamEvents(this._calendarService.calendarLastDate);
    };
    EmployeeCalendarComponent.prototype.setTeamEventDays = function (events) {
        var _this = this;
        this.addEventDisabled = false;
        this.events = tslib_1.__spread(this.eventsCompany, events.data.map(function (item) {
            var actual = moment(_this.viewDate).format('YYYY-MM-DD');
            var start = moment(item.start_datetime).format('YYYY-MM-DD');
            var end = moment(item.end_datetime).format('YYYY-MM-DD');
            var check = moment(actual).isBetween(start, end) || actual === start;
            if (!_this.addEventDisabled && check) {
                _this.addEventDisabled = true;
            }
            var c = _this.getEventColor(item.type);
            return new EmployeeCalendarEventModel({
                actions: [],
                id: item.id,
                start: item.start_datetime,
                end: item.end_datetime,
                title: _this._translateService.instant(item.title),
                color: {
                    primary: c.primary,
                    secondary: c.secondary
                },
                isRecurring: item.is_recurring,
                type: item.type,
                frequenceTypeOfRecurring: item.frequence_type_of_recurring,
                endOfRecurring: item.end_of_recurring,
                meta: {
                    location: '',
                    notes: item.type
                }
            });
        }));
    };
    /**
     * Before View Renderer
     *
     * @param {any} header
     * @param {any} body
     */
    EmployeeCalendarComponent.prototype.beforeMonthViewRender = function (_a) {
        var _this = this;
        var header = _a.header, body = _a.body;
        /**
         * Get the selected day
         */
        var _selectedDay = body.find(function (_day) {
            return _day.date.getTime() === _this.selectedDay.date.getTime();
        });
        if (_selectedDay) {
            /**
             * Set selected day style
             * @type {string}
             */
            _selectedDay.cssClass = 'cal-selected';
        }
    };
    EmployeeCalendarComponent.prototype.changeMonth = function (event) {
        var d = moment(event.date).format('YYYY-MM');
        this._calendarService.getMonthlyEvents(d);
    };
    /**
     * Day clicked
     *
     * @param {MonthViewDay} day
     */
    EmployeeCalendarComponent.prototype.dayClicked = function (day) {
        var date = day.date;
        var events = day.events;
        this.addEventDisabled = this.checkNonWorkingEvent(events);
        if (isSameMonth(date, this.viewDate)) {
            if ((isSameDay(this.viewDate, date) && this.activeDayIsOpen === true) || events.length === 0) {
                this.activeDayIsOpen = false;
            }
            else {
                this.activeDayIsOpen = true;
                this.viewDate = date;
            }
        }
        this.selectedDay = day;
        this.refresh.next();
    };
    /**
     * Event times changed
     * Event dropped or resized
     *
     * @param {CalendarEvent} event
     * @param {Date} newStart
     * @param {Date} newEnd
     */
    EmployeeCalendarComponent.prototype.eventTimesChanged = function (_a) {
        var event = _a.event, newStart = _a.newStart, newEnd = _a.newEnd;
        event.start = newStart;
        event.end = newEnd;
        // console.warn('Dropped or resized', event);
        this.refresh.next(true);
    };
    return EmployeeCalendarComponent;
}());
export { EmployeeCalendarComponent };
